<template>
    <card class="mb-5">
        <template slot="body">
            <h6 class="heading-small text-muted">Company Address Information</h6>
            <div class="row">
                <div class="col-lg-6 col-sm-12 mb-4">
                    <google-map @change="syncMapData" :initial-value="initialAddress" :initial-location="initialAddress.position" ></google-map>
                </div>
                <div class="col-lg-6 col-sm-12">
                    <div class="row">
                        <div class="col-lg-12">
                            <form-input
                                placeholder="Unit/House no, Building, Street name"
                                label="Unit/House no, Building, Street name"
                                v-model="form.specification"
                                ref="specification"
                            ></form-input>
                        </div>
                        <div class="col-lg-12">
                            <form-input
                                label="Barangay"
                                placeholder="Barangay"
                                v-model="form.barangay"
                                ref="barangay"
                            >
                            </form-input>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <form-input
                                placeholder="City/Municipality"
                                label="City/Municipality"
                                v-model="form.city"
                                ref="city"
                            ></form-input>
                        </div>
                        <div class="col-lg-6 col-sm-12">
                            <form-input
                                placeholder="Province"
                                label="Province"
                                v-model="form.province"
                                ref="province"
                            ></form-input>
                        </div>
                        <div class="col-lg-6">
                            <form-input
                                placeholder="Zipcode"
                                label="Zipcode"
                                v-model="form.zipcode"
                                ref="zipcode"
                            ></form-input>
                        </div>

                        <div class="col-sm-12">
                            <button v-if="!isRequesting" class="btn float-left" @click="back">
                                <i class="fas fa-angle-left mr-2"></i> Back
                            </button>
                            <button v-else class="btn float-left" disabled>
                                <i class="fas fa-angle-left mr-2"></i> Back
                            </button>

                            <button v-if="!isRequesting" class="btn btn-warning float-right" @click="next">
                                Next <i class="fas fa-angle-right ml-2"></i>
                            </button>
                            <button v-else class="btn btn-warning float-right" disabled>
                                <i class="fa fa-spinner fa-spin mr-2"></i> Please wait
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </card>
</template>
<script>
import mixins from "@utils/mixins";
import { validateShopAddress } from "../helpers";

export default {
    name: "AddressSection",

    computed: {
        parentFormData() {
            return this.$parent.$parent.data || {};
        },
        initialAddress() {
            return {
                address: { ...this.form },
                position: {
                    lat: parseFloat(this.form.latitude || 14.5995124),
                    lng: parseFloat(this.form.longitude || 120.9842195),
                    radius: 5,
                }
            };
        },
    },

    data: () => ({
        isRequesting: false,
        form: {
            specification: "",
            barangay: "",
            city: "",
            province: "",
            country: "",
            zipcode: "",
            latitude: "",
            longitude: "",
            place_id: "",
        }
    }),

    methods: {
        syncMapData(payload) {
            this.form.barangay = payload[0].address.barangay;
            this.form.city = payload[0].address.city;
            this.form.country = payload[0].address.country;
            this.form.latitude = payload[0].position.lat;
            this.form.longitude = payload[0].position.lng;
            this.form.province = payload[0].address.province;
            this.form.zipcode = payload[0].address.zipcode;
        },
        initialize() {
            this.isRequesting = false;
            this.form = {
                specification: this.parentFormData.specification || "",
                barangay: this.parentFormData.barangay || "",
                city: this.parentFormData.city || "",
                province: this.parentFormData.province || "",
                country: this.parentFormData.country || "",
                zipcode: this.parentFormData.zipcode || "",
                latitude: this.parentFormData.latitude || "",
                longitude: this.parentFormData.longitude || "",
                place_id: this.parentFormData.place_id || "",
            }
        },
        back() {
            this.$emit("back");
        },
        next() {
            this.isRequesting = true;
            validateShopAddress(this.form)
                .then(response => this.$emit("next", {...this.form}))
                .catch(error => {
                    console.log(error);
                    this.promptFormErrors(this.$refs, error)
                })
                .finally(() => this.isRequesting = false);
        },
    },

    mounted() {
        this.initialize();
    }
}
</script>